export const doActionWithStops = (e, action) => {
  if (!e) { return; }

  e.preventDefault();
  e.stopPropagation();

  if (action) { action(); }
};
